import React from 'react';
import PropTypes from 'prop-types';
import { converter } from 'helpers/converter';
import './Typography.scss';

const rElement = React.createElement;

const Typography = props => {
  const {
    children,
    element,
    className,
    apaKey,
    translations,
    ...others
  } = props;
  const classes = `Typography ${className}`;
  if (apaKey && translations) {
    const text = converter.convertApaUnicode(translations, apaKey, apaKey);
    return rElement(`${element}`, { className: classes, ...others }, text);
  }
  return rElement(`${element}`, { className: classes, ...others }, children);
};

Typography.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]),
  apaKey: PropTypes.string,
  translations: PropTypes.shape({}),
};

Typography.defaultProps = {
  children: null,
  element: 'div',
  apaKey: null,
  translations: null,
  className: '',
};

export default Typography;
